import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import Autocomplete from '../../components/Autocomplete'
import { withLoadingAsync, showModal } from '../../services/common-service'
import { getMessageTemplatesAsync } from '../../services/waba-service'
import { getBucketVariable, storeBucketVariable } from '../../services/bucket-service'
import sherlock from '../../assets/images/sherlock.png'

const Campaigns = () => {
    const [campaignsData, setCampaignsData] = useState([]);
    const [campaignsSelected, setCampaignsSelected] = useState(null);
    const [edited, setEdited] = useState(false);
    const [entryPointOptions, setEntryPointOptions] = useState([])
    const [templateOptions, setTemplateOptions] = useState([])
    const [templateData, setTemplateData] = useState([])
    const [templateButtons, setTemplateButtons] = useState({})
    const [templateVariables, setTemplateVariables] = useState({})
    const [botDestino, setBotDestino] = useState({});
    const [bucketCampaigns, setBucketCampaigns] = useState({});

    useEffect(() => {
        withLoadingAsync(async () => {
            await loadCampaignsDataAsync()
            await loadTemplatesAsync()
            await LoadEntryPointsAsync()
        })
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setCampaignsData((prevData) =>
            prevData.map((item) =>
            item.idCampanha === campaignsSelected.idCampanha ? campaignsSelected : item
            )
        );
    }, [campaignsSelected]);

    useEffect(() => {
        // eslint-disable-next-line
    }, [campaignsData])

    const LoadEntryPointsAsync = async () => {
        const bucketEntryPoints = await getBucketVariable("EntryPoints-Data-Plugin")
        console.log(bucketEntryPoints)
        if (bucketEntryPoints) {
            let objOptions = bucketEntryPoints["entryPoints"]
            .map(entryPoint => ({
                value: entryPoint.Mensagem,
                label: entryPoint.Mensagem
            }));

            setEntryPointOptions(objOptions)
        }
    }

    const loadTemplatesAsync = async () => {
        const templstesResponse = await getMessageTemplatesAsync()
        setTemplateData(templstesResponse.data)

        const approvedTemplates = templstesResponse.data
        .filter(template => template.status === "APPROVED")
        .map(template => ({
            value: template.name,
            label: template.name
        }));
        setTemplateOptions(approvedTemplates)
        loadTemplatesButtonsAsync(templstesResponse.data)
        loadTemplatesVariablesAsync(templstesResponse.data)
    }

    const loadTemplatesButtonsAsync = async (objTemplateData=templateData) => {
        const objTemplateButtons = {};
        objTemplateData.forEach((item) => {
            const obj = {
                possui: false,
                opcoes: []
            };
    
            const buttonsComponent = item.components.find(
                (component) => component.type === "BUTTONS"
            );
    
            if (buttonsComponent && buttonsComponent.buttons) {
                obj.possui = buttonsComponent.buttons.some(
                    (button) => button.type === "QUICK_REPLY"
                );
    
                obj.opcoes = buttonsComponent.buttons
                    .filter((button) => button.type === "QUICK_REPLY")
                    .map((button) => {return {"textoBotao": button.text, "mensagemRedirecionamento": "", "mensagens": []}});
            }
            objTemplateButtons[item.name] = obj;
        });
        setTemplateButtons(objTemplateButtons)
    }

    const loadTemplatesVariablesAsync = async (objTemplateData=templateData) => {
        const objTemplateVariables = {};
        objTemplateData.forEach((item) => {
            let variaveis = [];
    
            const bodyComponent = item.components.find(
                (component) => component.type === "BODY"
            );
    
            if (bodyComponent) {
                const regex = new RegExp("{{\\d+}}", 'g')
                const matches = bodyComponent.text.match(regex)

                if (matches && matches.length > 0) {
                    variaveis = matches
                    .map((match) => {return {"variavel": match, "conteudo": "", "dinamica": false}});
                }
                
            }
            objTemplateVariables[item.name] = variaveis;
        });
        console.log(objTemplateVariables)
        setTemplateVariables(objTemplateVariables)
    }

    const loadCampaignsDataAsync = async () => {
        const objBucketCampaigns = await getBucketVariable("CampaignsData")
        console.log(objBucketCampaigns)
        if (!objBucketCampaigns) {
            const initialData = {
                "botDestino": {
                    "master-state": "",
                    "stateId": "",
                    "flowId": "",
                    "token": ""
                },
                "campaignsData": []
            }
            await storeBucketVariable("CampaignsData", initialData)
            setBucketCampaigns(initialData)
            setCampaignsData([])
            setBotDestino(initialData.botDestino)
        } else {
            setBucketCampaigns(objBucketCampaigns)
            setCampaignsData(objBucketCampaigns["campaignsData"] || [])
            setBotDestino(objBucketCampaigns["botDestino"] || {
                "master-state": "",
                "stateId": "",
                "flowId": "",
                "token": ""
            })
        }
    }

    const newCampaign = (idCampanha) => {
        const objCampanha = {
            "template": "",
            "nomeCampanha": "",
            "idCampanha": idCampanha,
            "origem": "",
            "botoes": {
                "possui": false,
                "opcoes": []
            },
            "variaveis": [],
            "inputAberto": {
                "mensagens": [],
                "mensagemRedirecionamento": ""
            }
        }
        setCampaignsData(campaignsData => {
            const updatedList = [...campaignsData]
            updatedList.push(objCampanha)
            return updatedList
        })
        setCampaignsSelected(objCampanha)
        setEdited(true)
    }

    const handleDeleteCampaign = async (idCampanha) => {
        const { response } = await showModal(
            'Atenção',
            'Tem certeza que deseja excluir essa campanha?'
        );
        if (response) {
            setCampaignsData((prevData) =>
                prevData.filter((campanha) => campanha.idCampanha !== idCampanha)
            );
            
            if (campaignsSelected.idCampanha === idCampanha) {
                setCampaignsSelected({});
            }
            
            setEdited(true);
        }
    };

    const codigoSalesforce = () => {
        let messageParamsObject = [];
        let messageParamsEntries = [];
        
        if (campaignsSelected['variaveis'].length > 0) {
            campaignsSelected['variaveis'].forEach((variavel, index) => {
                const paramIndex = (index + 1).toString();
                const paramValue = variavel.dinamica 
                    ? `"', AttributeValue("${variavel.conteudo}"), '"`
                    : `"${variavel.conteudo}"`;
                
                messageParamsEntries.push(`"${paramIndex}": ${paramValue}`);
                messageParamsObject.push(`"${paramIndex}"`);
            });
        }
        
        // Construir payload condicionalmente com ou sem messageParams
        const hasParams = messageParamsEntries.length > 0 && messageParamsObject.length > 0;
        
        const audienceSection = hasParams 
            ? `"audience":{"recipient":"', @phone, '","messageParams":{ ${messageParamsEntries.join(",")}}}`
            : `"audience":{"recipient":"', @phone, '"}`;
        
        const messageSection = hasParams
            ? `"message":{"messageTemplate":"', @templateName, '","messageParams":[${messageParamsObject.join(",")}]}`
            : `"message":{"messageTemplate":"', @templateName, '"}`;
        
        return (`%%[ IF _messagecontext == 'SEND' THEN ]%%
%%[

Var @callStatus, @payloadmsg, @payloadIdCampanha, @payloadtemplate, @payloadTrackingEnvio
Var @templateName, @idCampanha, @atendente, @stateId, @flowId, @token, @bot
Var @name, @phone, @contactKey, @email, @guid, @JID, @urlBlipCommand, @urlBlipMessage

Set @templateName = '${campaignsSelected['template']}'
Set @idCampanha = '${campaignsSelected['idCampanha']}'
Set @stateId = '${botDestino['stateId']}'
Set @flowId = '${botDestino['flowId']}'
Set @bot = '${botDestino['master-state']}'

Set @token = '${botDestino['token']}'
Set @urlBlipCommand = 'https://genialinvestimentos.http.msging.net/commands'
Set @urlBlipMessage = 'https://genialinvestimentos.http.msging.net/messages'

Set @name = AttributeValue("FirstName")
Set @phone = AttributeValue("MobileNumber")
Set @contactKey = AttributeValue("ContactKey")
Set @email = AttributeValue("Email")
Set @guid = GUID()
Set @JID = JobId

Set @payloadtemplate = Concat('{"id":"',@guid,'0", "method" : "get", "to" : "postmaster@wa.gw.msging.net", "uri" : "/message-templates"}')
Set @payloadIdCampanha = Concat('{"id":"',@guid,'2","to":"postmaster@msging.net","method":"set","uri":"/contexts/',@phone,'@wa.gw.msging.net/idCampanha","type":"text/plain","resource":"',@idCampanha,'"}')
Set @payloadmsg = Concat('{"id":"', @guid, '1","to":"postmaster@activecampaign.msging.net","method":"set","type":"application/vnd.iris.activecampaign.full-campaign+json","uri":"/campaign/full","resource":{"campaign":{"name":"salesforce', @guid, '","campaignType":"Individual","flowId":"', @flowId, '","stateId":"', @stateId, '","masterstate":"', @bot, '@msging.net"},${audienceSection},${messageSection}}}')
Set @payloadTrackingEnvio = Concat('{"id":"',@guid,'3","to":"postmaster@analytics.msging.net","method":"set","type":"application/vnd.iris.eventTrack+json","uri":"/event-track","resource":{"category":"disparo salesforce","action":"',@templateName,'","contact":{"identity":"',@phone,'@wa.gw.msging.net"}}}')
Set @payloadTrackingEnvioAnalico = Concat('{"id":"',@guid,'4","to":"postmaster@analytics.msging.net","method":"set","type":"application/vnd.iris.eventTrack+json","uri":"/event-track","resource":{"category":"disparo salesforce analitico","action":"',@templateName,'|',@phone,'|',@guid,'","contact":{"identity":"',@phone,'@wa.gw.msging.net"}}}')

if empty(@phone) then
    SET @InsertDE = InsertDE("LOG_WPP", "ContactKey", v(@contactkey), "email", v(@email), "sentDate", NOW(), "name", v(@name), "phone", v(@phone), "message", v(@templateName), "messagetext", v(@payloadmsg), "status", "500", "reason", "Phone number not specified, API not sent", "guid", v(@guid), "key", v(@token), "jobid", v(@JID))
else
    set @templates = HttpPost(@urlBlipCommand, "application/json", @payloadtemplate, @templateStatus, "Authorization", @token)
    set @rowset = BuildRowsetFromJSON(@templateStatus,'$.resource.data[*]',1)
    set @rowCount = rowcount(@rowset)

    if @rowCount > 0 then
        for @i = 1 to @rowCount do
            set @row = row(@rowset, @i)
            set @templateNamelup = field(@row, "name")
            set @status = field(@row, "status")
            
            if @templateNamelup == @templateName AND @status == "APPROVED" then
                set @callCode2 = HttpPost(@urlBlipCommand, "application/json", @payloadIdCampanha, @callStatus2, "Authorization", @token)
                set @callCode = HttpPost(@urlBlipCommand, "application/json", @payloadmsg, @callStatus, "Authorization", @token)
                set @callCode3 = HttpPost(@urlBlipCommand, "application/json", @payloadTrackingEnvio, @callStatus3, "Authorization", @token)
                set @callCode4 = HttpPost(@urlBlipCommand, "application/json", @payloadTrackingEnvioAnalico, @callStatus4, "Authorization", @token)
                
                SET @InsertDE = InsertDE("LOG_WPP", "ContactKey", v(@contactkey), "email", v(@email), "sentDate", NOW(), "name", v(@name), "phone", v(@phone), "message", v(@templateName), "messagetext", v(@payloadmsg), "status", @callCode, "guid", v(@guid), "key", v(@token), "jobid", v(@JID))
            elseif @templateNamelup == @templateName AND @status != "APPROVED" then
                SET @InsertDE = InsertDE("LOG_WPP", "ContactKey", v(@contactkey), "email", v(@email), "sentDate", NOW(), "name", v(@name), "phone", v(@phone), "message", v(@templateName), "messagetext", v(@payloadmsg), "status", "400", "reason", "Template rejected", "guid", v(@guid), "key", v(@token), "jobid", v(@JID))
            endif
        next @i
    endif
endif

]%%
%%[ELSE]%%
%%[RaiseError("Whatsapp Enviado",1,"WhatsApp",314,1)]%%
%%[ENDIF]%%`
)

    }

    const handleUpdateCampaignsSelected = (updatedCampaignsSelected) => {
        setCampaignsSelected(updatedCampaignsSelected);
        setEdited(true);
    };

    const handleAddMessageToButton = (buttonIndex) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            botoes: {
                ...campaignsSelected.botoes,
                opcoes: campaignsSelected.botoes.opcoes.map((botao, index) =>
                    index === buttonIndex
                        ? {
                              ...botao,
                              mensagens: [...(botao.mensagens || []), ""],
                          }
                        : botao
                ),
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateMessage = (buttonIndex, messageIndex, value) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            botoes: {
                ...campaignsSelected.botoes,
                opcoes: campaignsSelected.botoes.opcoes.map((botao, index) =>
                    index === buttonIndex
                        ? {
                              ...botao,
                              mensagens: botao.mensagens.map((mensagem, i) =>
                                  i === messageIndex ? value : mensagem
                              ),
                          }
                        : botao
                ),
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleDeleteMessage = (buttonIndex, messageIndex) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            botoes: {
                ...campaignsSelected.botoes,
                opcoes: campaignsSelected.botoes.opcoes.map((botao, index) =>
                    index === buttonIndex
                        ? {
                              ...botao,
                              mensagens: botao.mensagens.filter(
                                  (_, i) => i !== messageIndex
                              ),
                          }
                        : botao
                ),
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateVariable = (variableIndex, value) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            variaveis: campaignsSelected.variaveis.map((variavel, index) =>
                index === variableIndex ? { ...variavel, conteudo: value } : variavel
            ),
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateVariableDynamic = (variableIndex, value) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            variaveis: campaignsSelected.variaveis.map((variavel, index) =>
                index === variableIndex ? { ...variavel, dinamica: value } : variavel
            ),
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };
    
    const handleAddMessageInputAberto = () => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            inputAberto: {
                ...campaignsSelected.inputAberto,
                mensagens: [...(campaignsSelected.inputAberto.mensagens || []), ""],
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateInputAbertoMessage = (index, value) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            inputAberto: {
                ...campaignsSelected.inputAberto,
                mensagens: campaignsSelected.inputAberto.mensagens.map((mensagem, i) =>
                    i === index ? value : mensagem
                ),
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateInputAbertoEntryPoint = (value) => {
        handleUpdateCampaignsSelected((prevState) => ({
          ...prevState,
          inputAberto: {
            ...prevState.inputAberto,
            mensagemRedirecionamento: value,
          },
        }));
      };
    
    const handleDeleteInputAbertoMessage = (index) => {
        const updatedCampaignsSelected = {
            ...campaignsSelected,
            inputAberto: {
                ...campaignsSelected.inputAberto,
                mensagens: campaignsSelected.inputAberto.mensagens.filter((_, i) => i !== index),
            },
        };
    
        handleUpdateCampaignsSelected(updatedCampaignsSelected);
    };

    const handleUpdateCampaingField = (obj) => {
        setCampaignsSelected((prevState) => ({
          ...prevState,
          ...obj,
        }));
    };

    const handleCopyToClipboard = () => {
        const textArea = document.createElement("textarea");
        textArea.value = codigoSalesforce();
        console.log(textArea.value)
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
    };

    return (
        <>
            <div className="vh-90 ph1 ph4-m ph5-ns mt3">
                <div className="flex justify-end mb3">
                    <div className="flex items-center pl3">
                        <bds-button-icon
                            variant="secondary"
                            size="short"
                            icon="refresh"
                            onClick={() => {
                                withLoadingAsync(async () => {
                                    await loadCampaignsDataAsync()
                                })
                            }}
                        />
                    </div>
                    <div className="pl3">
                        <bds-button
                            variant='primary'
                            onClick={() => {
                                newCampaign(uuidv4())
                            }}
                        >
                            Nova Campanha
                        </bds-button>
                    </div>
                    <div className="flex items-center pl3">
                        <bds-button
                            variant='primary'
                            disabled={!edited}
                            onClick={() => {
                                withLoadingAsync(async () => {
                                    await storeBucketVariable("CampaignsData", { ...bucketCampaigns, campaignsData: campaignsData })

                                    setEdited(false)
                                })
                            }}
                        >
                            Salvar
                        </bds-button>
                    </div>
                </div>
                <div className="flex">
                    <div className='w-30'>
                        <div>
                            <bds-paper elevation="static">
                                {campaignsData?.map((item, index) => (
                                    <div className="flex justify-between items-center pt1 pb1">
                                            <div
                                                className='pointer ml3 w-100'
                                                onClick={() => {
                                                    setCampaignsSelected(item)
                                                }}
                                            >
                                                <bds-typo variant="fs-16" id={"texto " + index}>
                                                    {item.nomeCampanha}
                                                </bds-typo>
                                                <bds-typo variant="fs-14" id={"texto " + index}>
                                                    {item.template}
                                                </bds-typo>
                                            </div>
                                        <div className="flex justify-end items-center">
                                            <div className='mr1'>
                                                <bds-button-icon
                                                    icon="trash"
                                                    id={"open " +index}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => {
                                                        handleDeleteCampaign(item.idCampanha)
                                                    }}
                                                />
                                            </div>
                                            <div className='mr1'>
                                                <bds-button-icon
                                                    icon="notes"
                                                    id={"open " +index}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => {
                                                        setCampaignsSelected(item)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </bds-paper>
                        </div>
                    </div>
                    <div className='w-70 pl3'>
                        {campaignsSelected &&
                            <bds-paper elevation="static">
                            <div className='flex pa3'>
                                <div className='w-50'>
                                    <div className="w-100 mb3">
                                        <bds-input
                                            label="ID da Campanha"
                                            id="ID da Campanha"
                                            disabled={true}
                                            value={campaignsSelected.idCampanha}
                                        />
                                    </div>
                                    <div className="w-100 mb3">
                                        <bds-input
                                            label="Nome da campanha"
                                            id="Nome da campanha"
                                            value={campaignsSelected.nomeCampanha}
                                            onInput={(e) => {
                                                handleUpdateCampaingField({"nomeCampanha": e.target.value})
                                            }}
                                        />
                                    </div>
                                    <div className="w-100 mb3">
                                        <bds-input
                                            label="Origem da campanha"
                                            id="Origem da campanha"
                                            value={campaignsSelected.origem}
                                            onInput={(e) => {
                                                handleUpdateCampaingField({"origem": e.target.value})
                                            }}
                                        />
                                    </div>
                                    <div className="w-100 mb3">
                                        <Autocomplete
                                            label="Mensagem de Template"
                                            key={campaignsSelected.template}
                                            value={campaignsSelected.template}
                                            optionsPosition="bottom"
                                            options={templateOptions}
                                            onChange={(e) => {
                                                handleUpdateCampaingField({
                                                    "template": e.target.value,
                                                    "botoes": templateButtons[e.target.value] || {"possui": false, "opcoes": []},
                                                    "variaveis": templateVariables[e.target.value] || []
                                                })
                                            }}
                                            placeholder="Selecione uma opção"
                                        />
                                    </div>
                                    {campaignsSelected.variaveis?.map((item, index) => (
                                        <div className='flex justify-between mb3'>
                                            <div key={index} className="w-100 mb3">
                                                <bds-input
                                                    label={"Variavel " + item.variavel}
                                                    value={item.conteudo}
                                                    onInput={(e) => handleUpdateVariable(index, e.target.value)}
                                                />
                                            </div>
                                            <div className='ml3'>
                                                <bds-typo variant="fs-12" bold='bold'>Dinamica</bds-typo>
                                                <div className="flex items-center">
                                                    <div className='mr2'>
                                                        <bds-switch
                                                            id="switch-2"
                                                            onInput={(e) => handleUpdateVariableDynamic(index, !item.dinamica)}
                                                            name="string"
                                                            disabled="false"
                                                            checked={item.dinamica}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className='flex justify-center items-center'>
                                        <bds-button
                                            variant="outline"
                                            color="primary"
                                            icon='copy'
                                            onClick={handleCopyToClipboard}
                                        >
                                            Copiar codigo SalesForce
                                        </bds-button>
                                    </div>
                                </div>
                                <div>
                                    <bds-divider
                                        styleType="solid"
                                        orientation="vertical"
                                        color="divider-1"
                                    />
                                </div>
                                <div className='w-50'>
                                    <div className='flex justify-between mb3'>
                                        <div className='flex items-center'>
                                            <bds-typo variant="fs-18">
                                                Caso o usuário envie uma mensagem
                                            </bds-typo>
                                        </div>
                                        <div className='flex items-center'>
                                            <bds-button
                                                variant='tertiary'
                                                size='short'
                                                icon='plus'
                                                onClick={handleAddMessageInputAberto}
                                            >
                                                Mensagem
                                            </bds-button>
                                        </div>
                                    </div>
                                    <div className="mb3 w-100">
                                        <Autocomplete
                                            id="EntryPoint"
                                            label="EntryPoint"
                                            key={campaignsSelected.inputAberto.mensagemRedirecionamento}
                                            value={campaignsSelected.inputAberto.mensagemRedirecionamento}
                                            optionsPosition="bottom"
                                            options={entryPointOptions}
                                            onChange={(e) => {
                                                handleUpdateInputAbertoEntryPoint(e.target.value)
                                            }}
                                            placeholder="Selecione uma opção"
                                        />
                                    </div>
                                    {campaignsSelected.inputAberto.mensagens?.map((item, index) => (
                                        <div key={index} className="flex justify-end items-center mb3 w-100">
                                            <bds-input
                                                label="Mensagem de texto"
                                                value={item}
                                                is-textarea
                                                rows="2"
                                                expand="true"
                                                onInput={(e) =>
                                                    handleUpdateInputAbertoMessage(index, e.target.value)
                                                }
                                            />
                                            <div>
                                                <bds-button-icon
                                                    icon="trash"
                                                    id={`delete-inputAberto-${index}`}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => handleDeleteInputAbertoMessage(index)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    {campaignsSelected.botoes.opcoes?.map((item, buttonIndex) => (
                                        <div key={buttonIndex}>
                                            <div className='flex justify-between mb3'>
                                                <div className='flex items-center'>
                                                    <bds-typo variant="fs-18">
                                                        Botão: {item.textoBotao}
                                                    </bds-typo>
                                                </div>
                                                <div className='flex items-center'>
                                                    <bds-button
                                                        variant='tertiary'
                                                        size='short'
                                                        icon='plus'
                                                        onClick={() => handleAddMessageToButton(buttonIndex)}
                                                    >
                                                        Mensagem
                                                    </bds-button>
                                                </div>
                                            </div>
                                            <div className="mb3 w-100">
                                                <Autocomplete
                                                    id={`EntryPoint-${buttonIndex}`}
                                                    label="EntryPoint"
                                                    key={campaignsSelected.inputAberto.mensagemRedirecionamento}
                                                    value={item.mensagemRedirecionamento}
                                                    optionsPosition="bottom"
                                                    options={entryPointOptions}
                                                    onChange={(e) => {
                                                        const updatedValue = e.target.value;
                                                        setCampaignsSelected((prevState) => {
                                                            const updatedOpcoes = [...prevState.botoes.opcoes];
                                                            updatedOpcoes[buttonIndex].mensagemRedirecionamento = updatedValue;
                                                            return {
                                                                ...prevState,
                                                                botoes: {
                                                                    ...prevState.botoes,
                                                                    opcoes: updatedOpcoes,
                                                                },
                                                            };
                                                        });
                                                    }}
                                                    placeholder="Selecione uma opção"
                                                />
                                            </div>
                                            {/* 
                                            <div className="mb3 w-100">
                                                <bds-input
                                                    label="EntryPoint"
                                                    id={`EntryPoint-${buttonIndex}`}
                                                    value={item.mensagemRedirecionamento}
                                                    onInput={(e) => {
                                                        const updatedValue = e.target.value;
                                                        setCampaignsSelected((prevState) => {
                                                            const updatedOpcoes = [...prevState.botoes.opcoes];
                                                            updatedOpcoes[buttonIndex].mensagemRedirecionamento = updatedValue;
                                                            return {
                                                                ...prevState,
                                                                botoes: {
                                                                    ...prevState.botoes,
                                                                    opcoes: updatedOpcoes,
                                                                },
                                                            };
                                                        });
                                                    }}
                                                />
                                            </div> */}
                                            {item.mensagens?.map((mensagem, messageIndex) => (
                                                <div key={messageIndex} className="flex justify-end items-center mb3 w-100">
                                                    <bds-input
                                                        label="Mensagem de texto"
                                                        value={mensagem}
                                                        is-textarea
                                                        rows="2"
                                                        expand="true"
                                                        onInput={(e) =>
                                                            handleUpdateMessage(buttonIndex, messageIndex, e.target.value)
                                                        }
                                                    />
                                                    <div>
                                                        <bds-button-icon
                                                            icon="trash"
                                                            id={`delete-${buttonIndex}-${messageIndex}`}
                                                            variant="secondary"
                                                            size="short"
                                                            onClick={() => handleDeleteMessage(buttonIndex, messageIndex)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </bds-paper>
                        }
                        {!campaignsSelected &&
                            <div className="mt5">
                                <div className='flex justify-center'>
                                    <img className="w-10" src={sherlock} alt="sherlock" />
                                </div>
                                <div className='flex justify-center'>
                                    <h2 style={{ color: "#6E7B91" }}>
                                        Você ainda não selecionou uma campanha, escolha uma campanha para iniciar!
                                    </h2>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

Campaigns.propTypes = {};

export default Campaigns;